import React from 'react';

import { CopyModule } from '@pkg/components';
import { useMediaQuery } from '@pkg/providers';

interface Props {
    emojiId: string;
    directionUp?: boolean;
    directionDown?: boolean;
    directionLeft?: boolean;
    directionRight?: boolean;
    customButton: React.ReactNode;
}

export const YatShareButton = ({
    emojiId,
    directionUp = false,
    directionDown = false,
    directionLeft = false,
    directionRight = false,
    customButton,
}: Props) => {
    const { tablet } = useMediaQuery();

    return (
        <CopyModule
            iconSize={'default'}
            emojiId={emojiId}
            directionUp={directionUp}
            directionDown={directionDown}
            directionRight={!tablet || directionRight}
            directionLeft={tablet || directionLeft}
        >
            {customButton}
        </CopyModule>
    );
};
